import * as React from "react";
import { Link } from "react-ui";
import { BookClosedHelpIcon, SearchLoupeIcon } from "@skbkontur/icons";

import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { NORMATIV_BASE_CLICK, NORMATIV_HELP_CLICK } from "../../metricsAction";

import { normativeHelpIds as helpIds } from "./helpIds";
import { Root } from "./NormativeHelp.styles";

export interface NormativeHelpProps {
    commonHelpId?: string;
    gap?: string;
    knd?: string;
    helpCommonUrl?: string;
    helpId?: string | number;
    helpNormativeCommon?: string;
    helpUrl?: string;
    normativeUrl: undefined | string;
    isReadOnly?: boolean;
}

export const NormativeHelp = (props: NormativeHelpProps) => {
    if (props.isReadOnly) {
        return <></>;
    }
    return <InteractiveHelp {...props} />;
};

const InteractiveHelp = (props: NormativeHelpProps) => {
    const track = useMetrics();

    const handleOnClickNormativeHelp = () => {
        track(NORMATIV_HELP_CLICK, {});
    };

    const handleOnClickNormativeBase = () => {
        track(NORMATIV_BASE_CLICK, {});
    };

    function getFormFillingHref(normativeUrl: string): string | undefined {
        if (props.helpUrl != undefined) {
            return joinUrls(normativeUrl, props.helpUrl);
        }
        const resultById = props.helpId != undefined ? helpIds[props.helpId] : undefined;
        if (resultById != undefined) {
            return joinUrls(normativeUrl, resultById);
        }
        return undefined;
    }

    function getNormativeBasisHref(normativeUrl: string): undefined | string {
        if (props.commonHelpId) {
            return joinUrls(normativeUrl, `go.aspx?id=${props.commonHelpId}&from=extern`);
        }
        let normativeCommonHelpUrl = props.helpCommonUrl;
        if (normativeCommonHelpUrl == undefined) {
            normativeCommonHelpUrl =
                props.helpNormativeCommon != undefined ? helpIds[props.helpNormativeCommon] : undefined;
        }
        if (normativeCommonHelpUrl != undefined) {
            return joinUrls(
                normativeUrl,
                `?query=${encodeURIComponent(normativeCommonHelpUrl)}` +
                    `&searching=true&actualonly=false&areaid=0&searchsource=2`
            );
        }
        return undefined;
    }

    const { normativeUrl } = props;

    if (!normativeUrl) {
        return <div />;
    }

    const formFillingUrl = getFormFillingHref(normativeUrl);
    const normativeBasisHref = getNormativeBasisHref(normativeUrl);
    const gapStyle = { marginRight: Number(props.gap ?? 40) };

    return (
        <Root>
            {formFillingUrl != undefined && (
                <span style={gapStyle}>
                    <Link
                        href={formFillingUrl}
                        target="_blank"
                        onClick={handleOnClickNormativeHelp}
                        icon={<BookClosedHelpIcon size={14} />}>
                        Порядок заполнения
                    </Link>
                </span>
            )}
            {normativeBasisHref && (
                <span style={gapStyle}>
                    <Link
                        href={normativeBasisHref}
                        target="_blank"
                        onClick={handleOnClickNormativeBase}
                        icon={<SearchLoupeIcon size={14} />}>
                        Нормативная база
                    </Link>
                </span>
            )}
            {props.knd && <span style={gapStyle}>Форма по КНД {props.knd}</span>}
        </Root>
    );
};

function removeTrailingSlashes(url: string): string {
    return url.replace(/\/+$/i, "");
}

function removeLeadingSlashes(url: string): string {
    return url.replace(/^\/+/i, "");
}

function joinUrls(prefix: string, suffix: string): string {
    if (suffix.startsWith("?")) {
        return removeTrailingSlashes(prefix) + suffix;
    }
    return removeTrailingSlashes(prefix) + "/" + removeLeadingSlashes(suffix);
}
